import { useDispatch } from "react-redux";
import { demographics } from "./demographics";
import { setDemographics } from "../../../../entities/patient-stats/demographics/demographics.slice";

export const useGetDemographics = () => {
  const dispatch = useDispatch();

  const getDemographicsByPatientId = async (patientId: string) => {
    const res = await new Promise((resolve) => {
      setTimeout(() => {
        const filtered = demographics.filter(
          (p) => String(p.patientId) === patientId,
        );
        resolve(filtered[0]);
      }, 400);
    });

    dispatch(setDemographics(res));
  };

  return {
    getDemographicsByPatientId,
  };
};
